// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"settingsChorusView_wrapper__i96ri","title":"settingsChorusView_title__3Rb8V","content":"settingsChorusView_content__H_8GK"};